import _ from 'lodash'
import type {DocumentManager} from '@wix/document-manager-core'
import type {Pointer} from '@wix/document-services-types'
import * as constants from '../../../../constants/constants'
import type {MasterPageMigrator} from '../dataMigrationRunner'
import {stripHashIfExists} from '../../../../utils/refArrayUtils'

const getCleanedPages = (documentManager: DocumentManager, pages: string[]): string[] =>
    _.filter(pages, pageId => {
        const dataPointer = documentManager.pointers.getPointer(stripHashIfExists(pageId), constants.DATA_TYPES.data)
        const structurePointer = documentManager.pointers.getPointer(
            stripHashIfExists(pageId),
            constants.VIEW_MODES.DESKTOP
        )
        return !!documentManager.dal.get(dataPointer) && !!documentManager.dal.get(structurePointer)
    })

const membersPageGroup = (value: any) => value.type === 'PagesGroupData' && value.groupName === 'members_pages_group'

const cleanPageGroup = (documentManager: DocumentManager, groupPointer: Pointer) => {
    const groupData = documentManager.dal.get(groupPointer)
    if (groupData.pages) {
        const {pages} = groupData
        const cleanPages = getCleanedPages(documentManager, pages)
        if (pages.length !== cleanPages.length) {
            const newValue = _.cloneDeep(groupData)
            newValue.pages = cleanPages
            documentManager.dal.set(groupPointer, newValue)
        }
    }
}

const migrateMasterPage = (documentManager: DocumentManager) => {
    if (documentManager.config.loadingPartialPages) {
        return
    }
    const membersPageGroupPointers = documentManager.pointers.data.getDataItemsWithPredicate(
        membersPageGroup,
        constants.MASTER_PAGE_ID
    )
    _.forEach(membersPageGroupPointers, groupPointer => cleanPageGroup(documentManager, groupPointer))
}

const name = 'removeBrokenMemberPages'
const disableVersioning = (documentManager: DocumentManager) => documentManager.config.loadingPartialPages ?? false
const version = 4

export const removeBrokenMemberPages: MasterPageMigrator = {
    migrateMasterPage,
    disableVersioning,
    name,
    version
}
